import React from 'react';
import Immutable from 'seamless-immutable';
import PropTypes from 'prop-types';
import './AnsibleHostInventory.scss';
import ReportJsonViewer from '../../../ReportJsonViewer';

const AnsibleHostInventory = ({ inventoryData }) => {
  const mutableInventory =
    inventoryData && Immutable.asMutable(inventoryData, { deep: true });

  return (
    <div className="ansible-host-inventory">
      <ReportJsonViewer data={mutableInventory} />
    </div>
  );
};

AnsibleHostInventory.propTypes = {
  inventoryData: PropTypes.object.isRequired,
};

export default AnsibleHostInventory;



// WEBPACK FOOTER //
// /builddir/build/BUILDROOT/rubygem-foreman_ansible-9.0.1-1.fm3_4.el8.noarch/usr/share/gems/gems/foreman_ansible-9.0.1/webpack/components/AnsibleHostDetail/components/AnsibleHostInventory/AnsibleHostInventory.js